module.exports = __webpack_public_path__ + "static/media/past_project.f7586dbf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/past_project.svg
// module id = 520
// module chunks = 0